<template>
  <DetailView
    v-if="panelOptionsDefinition"
    :schema="panelOptionsDefinition.schema"
    :item="panelOptionsDefinition.item"
    :hide-edit-btn="true"
    display-in="info" />
</template>

<script>
import { mapState } from 'vuex'
import DetailView from 'schema-view/src/components/DetailView'

export default {
  computed: {
    ...mapState('schema-view', [
      'panelOptionsDefinition'
    ])
  },
  methods: {

  },
  components: {
    DetailView
  }
}
</script>
